import { nanoid } from "@reduxjs/toolkit";

const makeDateHierarchy = ({
  isDateHierarchyTure,
  dataSourceID,
  rowDateItem,
}) => {
  console.log(rowDateItem);
  if (rowDateItem !== undefined) {
    const dateHirarchyArrayItems = [
      { dateUnit: "Year", dateFormat: { label: "FY 2024", value: "%Y" } },
      {
        dateUnit: "Quarter",
        dateFormat: { label: "Q1 FY2024", value: "Qx" },
      },
      { dateUnit: "Month", dateFormat: { label: "January", value: "%M" } },
      { dateUnit: "Week", dateFormat: { label: "WK-24", value: "Wx" } },
      {
        dateUnit: "Day",
        dateFormat: { label: "14.01.2024", value: "%d.%m.%Y" },
      },
    ];
    const hierarchyColumn = {
      rename: rowDateItem.rename,
      uuid: rowDateItem.uuid,
      columnName: rowDateItem.columnName,
      dataType: "Hierarchy",
      columnType: "hierarchy",
      hierarchyType: "Date",
    };
    console.log(hierarchyColumn);

    // Find the index of the starting dateUnit
    const startIndex = dateHirarchyArrayItems.findIndex(
      (item) => item.dateUnit === rowDateItem.dateUnit
    );

    // Filter the array starting from the matched dateUnit
    const filteredHierarchyArrayItems =
      startIndex !== -1
        ? dateHirarchyArrayItems.slice(startIndex)
        : dateHirarchyArrayItems;
    console.log(filteredHierarchyArrayItems);

    // Map to create the hierarchy array
    const hierarchyArray = filteredHierarchyArrayItems.map((item, index) => {
      return {
        _id: rowDateItem._id,
        rename: rowDateItem.rename,
        uuid: rowDateItem.uuid,
        dataType: rowDateItem.dataType,
        columnName: rowDateItem.columnName,
        dateFormat: index === 0 ? rowDateItem.dateFormat : item.dateFormat,
        dateUnit: index === 0 ? rowDateItem.dateUnit : item.dateUnit,
        yearType: rowDateItem.yearType || "FY",
        nanoId: item.nanoId || nanoid(),
      };
    });
    console.log(hierarchyArray);

    return {
      hierarchyColumn: hierarchyColumn,
      dataSourceID,
      hierarchyArray,
    };
  }
  return undefined;
};

export { makeDateHierarchy };
